module.exports = __webpack_public_path__ + "img/60.66d767d6.webp";